"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupplyRegisterInfo = exports.mapMeterReadingQueryKapiToMeterReadingCX = exports.sortReadingsByLatest = exports.filterReadingMap = exports.mapMeterReading = void 0;
var utils_1 = require("../../utils");
var mapMeterReading = function (_a, mpxn) {
    var _b = _a.node, reading = _b.reading, __typename = _b.__typename;
    if (__typename === 'ValidReading' &&
        reading.__typename === 'ElectricityMeterRead') {
        var mappedRead = (0, utils_1.mapKapiElectricityMeterReadToLegacy)(reading);
        if (mappedRead) {
            return __assign(__assign({}, mappedRead), { mpxn: mpxn });
        }
    }
    return null;
};
exports.mapMeterReading = mapMeterReading;
var filterReadingMap = function (item) { return !!item; };
exports.filterReadingMap = filterReadingMap;
var flattenReadingMap = function (meterReadings, meterReading) { return __spreadArray(__spreadArray([], __read(meterReadings), false), __read(meterReading), false); };
var sortReadingsByLatest = function (a, b) {
    return new Date(b.readingDateTime).getTime() - new Date(a.readingDateTime).getTime();
};
exports.sortReadingsByLatest = sortReadingsByLatest;
var mapMeterReadingQueryKapiToMeterReadingCX = function (data) {
    return data.account.accountSupplyPoints
        ? data.account.accountSupplyPoints
            .map(function (accountSupplyPoint) {
            return accountSupplyPoint.meterReads.edges
                .map(function (edge) {
                return (0, exports.mapMeterReading)(edge, accountSupplyPoint.supplyPoint.sprn);
            })
                // Typescipt filter doesn't remove undefined
                .filter(exports.filterReadingMap);
        })
            .reduce(flattenReadingMap, [])
            .sort(exports.sortReadingsByLatest)
        : [];
};
exports.mapMeterReadingQueryKapiToMeterReadingCX = mapMeterReadingQueryKapiToMeterReadingCX;
var getSupplyRegisterInfo = function (data) {
    return (data.account.accountSupplyPoints &&
        data.account.accountSupplyPoints.flatMap(function (_a) {
            var _b = _a.supplyPoint, meterTechnicalDetails = _b.meterTechnicalDetails, sprn = _b.sprn;
            return meterTechnicalDetails === null || meterTechnicalDetails === void 0 ? void 0 : meterTechnicalDetails.flatMap(function (meterTechnicalDetail) {
                return meterTechnicalDetail.registers.map(function (_a) {
                    var registerId = _a.registerId, timingCategory = _a.timingCategory;
                    return ({
                        mpxn: sprn,
                        registerId: registerId,
                        timingCategory: timingCategory !== null && timingCategory !== void 0 ? timingCategory : null,
                    });
                });
            });
        })) ||
        [];
};
exports.getSupplyRegisterInfo = getSupplyRegisterInfo;
